import React, { Fragment } from 'react';
import Facebook from './facebook/share-button';
import Whatsapp from './whatsapp/share-button';

export default function ShareButtons({ imageUrl, title, date, reference, distribution, supplierId, price }) {
  const host = `https://${window.location.hostname}`;
  const urlString = window.location.href;
  const url = new URL(urlString);
  const urlImg = encodeURIComponent(imageUrl);
  const titleForView = title.replace(' ', '%20');
  const titleForUrl = title.replace(' ', '-');
  const packagesPath = process.env.RAZZLE_URL_PATH;
  const parcialUrl = new URL(`${host}${packagesPath}/trips/${
    titleForUrl}/?t=${
    reference}&h=${
    distribution}&p=${
    supplierId}&i=${
    url.searchParams.get('i')}&s=${
    url.searchParams.get('s')}&m=${
    url.searchParams.get('m')}&d=${
    url.searchParams.get('d')}&ngrupo=${
    url.searchParams.get('ngrupo')}&nroComb=${
    url.searchParams.get('nroComb')}&origen=${
    url.searchParams.get('origen')}`);
  const urlShare = encodeURIComponent(parcialUrl);
  return (
    <Fragment>
      <Facebook
        img={urlImg}
        url={urlShare}
        date={date}
        title={titleForView}
        host={host}
        price={price}
      />
      <Whatsapp
        img={urlImg}
        url={urlShare}
        date={date}
        title={titleForView}
        host={host}
        price={price}
      />
    </Fragment>
  );
}
